<template>
  <div>
    <div id="chart-container" class="row">
      <div class="col-12">
        <div v-show="this.$parent.getDisplayView() && getDisplayView()" id="base-rank-data-container" class="chart-data">
          <chart-data-table
            v-show="this.$parent.getDisplayView() && getDisplayView() && displayRankings"
            ref="baseRankDataTable"
            :data-container-id="'base-rank-data-container'"
            :container-id="'base-rank'"
            :report-page-type-name="'Table - Base Rank'"
            :is-saved-card="this.$parent.clientChart.clientChartId != 0" 
            :insight-modal-id="'base-rank-table'"
            :chart-data="this.table.data"
            v-bind:row-start-position="6"
            :column-defs="chart.columnDefs"
            :use-alternate-title="useAlternateTitle"
            :table-class="'table display row-border table-hover'"
            :table-width="'auto'"
            :table-title="this.table.title"
            :is-insider-user="this.$parent.isInsiderUser"
            :inputDownloadFileName="`${chartTypeTitle} Rank`"
          ></chart-data-table>
        </div>
        <div v-show="this.$parent.getDisplayView() && getDisplayView() && !displayRankings" class="chart-data">There is not enough data for rankings</div>  
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div v-show="this.$parent.getDisplayView() && getDisplayView()" id="base-rank-with-competitors-data-container" class="chart-data">
          <chart-data-table
            v-show="this.$parent.getDisplayView() && getDisplayView() && displayRankingsForCompetitors"
            ref="baseRankWithCompetitorsDataTable"
            :data-container-id="'base-rank-with-competitors-data-container'"
            :container-id="'base-rank-with-competitors'"
            :report-page-type-name="'Table - Base Rank'"
            :is-saved-card="this.$parent.clientChart.clientChartId != 0" 
            :insight-modal-id="'base-rank-with-competitors-table'"
            :chart-data="this.tableWithCompetitors.data"
            :use-alternate-title="useAlternateTitle"
            v-bind:row-start-position="6"
            :column-defs="this.tableWithCompetitors.columnDefs"
            :table-class="'table display row-border table-hover'"
            :table-width="'auto'"
            :table-title="this.tableWithCompetitors.title"
            :is-insider-user="this.$parent.isInsiderUser"
            :inputDownloadFileName="`${chartTypeTitle} Competitors Rank`"
          ></chart-data-table>
        </div>
      </div>
    </div>    
    <insights
      ref="insightsTable"
      :modal-name="'base-rank-table'"
      :report-page-type-name="'Table - Base Rank'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    
  </div>
</template>
<script>
import ChartCompanyMixins from "../../../mixins/ChartCompanyMixins.vue";
import $ from "jquery";

import TableService from "../../../services/table.service";
import ReportService from "../../../services/report.service";
import ErrorService from "../../../services/error.service";
import AdminService from "../../../services/admin.service";
import PrintAndCopyService from "../../../services/print.and.copy.service";

export default {
  name: "BaseRank",
  mixins: [ChartCompanyMixins],
  components: { },
  data() {
    return {
      title: "Moat Profile",
      pageNumber: 5,
      
      
      table: {
        id: "",
        data: {},
        title: "<div class='title'><h4 class='text-primary'>Moneyball</h4></div>"
      },
      tableWithCompetitors: {
        id: "",
        data: {},
        title: "<div class='title'><h4 class='text-primary'>Moneyball</h4></div>"
      },
      isMobile: false,
      useAlternateTitle: false,
      displayRankings: false,
      displayRankingsForCompetitors: false,
      redrawAdditionalWidgets: true,
      moatChartOptions: {},
      snapModalContent: PrintAndCopyService.getSnapMessage(),
      titleSuffix: "",
    };
  },
  props: {
    inputData: {
      type: Object,
      default: function() {
        return {};
      }
    },
    inputDataForCompetitors: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  methods: {
    clearTable(){
      this.table =  {
        id: "",
        data: {},
        title: "<h4 class='text-primary'>Moneyball</h4>"
      };
      this.tableWithCompetitors =  {
        id: "",
        data: {},
        title: "<h4 class='text-primary'>Moneyball</h4>"
      };

      this.setDisplayView(false);
    },
    async snapChart(displayLegend, snapContainerId) {
      PrintAndCopyService.initializeSnapChart(displayLegend, snapContainerId, this); 
    },
    displayInsights(insightModalId, reportPageTypeName) {
      if (reportPageTypeName == "Table - Base Rank") {
        this.$refs.insightsTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsTable.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      }
    },
    async processChartDataForCompetitors(){
        let returnData = JSON.parse(JSON.stringify(this.inputDataForCompetitors));
        this.tableWithCompetitors.id = returnData["containerId"];
        let rows = returnData["rows"];
        this.tableWithCompetitors.columnDefs = this.buildColumnsForRanks(returnData["cols"]);
        this.tableWithCompetitors.data = returnData;
        let otherData = returnData["otherData"];
        if (typeof otherData["tableTitle"] != "undefined"){
          this.tableWithCompetitors.title = otherData["tableTitle"];
        } else {
          this.tableWithCompetitors.title = "Rank";
        }
        this.displayRankingsForCompetitors = true;
    },
    async processChartData() {
      try {
        let returnData = JSON.parse(JSON.stringify(this.inputData));
        let containerId = returnData["containerId"];
        let columns = returnData["cols"];
        let rows = returnData["rows"];
        this.table.id = containerId;
        this.chart.columnDefs = this.buildColumnsForRanks(columns);
        this.$parent.setChartResults(returnData["companyList"]);
        let otherData = returnData["otherData"];
        let titleSuffix = otherData["titleSuffix"];
        if (typeof titleSuffix != "undefined" && titleSuffix != null && titleSuffix != "") {
          this.titleSuffix = titleSuffix;
        }
        this.$parent.surveyGroupByTierList = otherData["surveyGroupByTierList"];
        this.$parent.baseGroupName = otherData["baseGroupName"];
        if (typeof otherData["tableTitle"] != "undefined"){
          this.table.title = otherData["tableTitle"];
        } else {
          this.table.title = "Rank";
        }
        // if this.table.title contains the work Moneyball then set isMoneyball to true
        if (this.table.title.indexOf("Moneyball") !== -1) {
          this.useAlternateTitle = true;
        } else {
          this.useAlternateTitle = false;
        }
        this.table.data = returnData;

        this.$parent.$data.criteriaResultsList = AdminService.removeByName(returnData.criteriaList, "Competitor");        
        if (rows.length == 1){
          this.displayRankings = false;
        } else { 
          this.displayRankings = true;
        }
        if (!$.isEmptyObject(this.inputDataForCompetitors)) {        
          await this.processChartDataForCompetitors();
        } else {
          this.displayRankingsForCompetitors = false;
        }
        this.$parent.setDisplayView(true);
        this.setDisplayView(true);
        this.$root.processServerResponse();
        setTimeout(() => {
            if (containerId == "base-rank") {
                this.saveReportPage("base-rank");
            }        
        }, 1000);        
        this.buildClientChart();
      } catch (err) {
        ErrorService.processException("BaseRank.processChartData", err, "chart", this);
      }
    },
    async saveReportPage(containerId) {
      if (this.$parent.clientChart.clientChartId != 0 && this.isGenerateReportRunning()) {
        await ReportService.saveReportTableFile(
          this.$refs.baseRankDataTable.getTableData(),
          "Table - Base Rank", 
          this.$parent.clientChart, 
          this.saveReportTableFileCallback, 
          this
        );

        await ReportService.saveReportPage(
          this.getReportTableContent(containerId), 
          "Table - Base Rank", 
          this.$parent.clientChart, 
          this.saveReportPageCallback, 
          this
        );
      }
    },
    saveAllReportPages() {
      this.saveReportPage("base-rank");
    },
    buildColumnsForRanks(columns){
      let returnColumns = [];
      returnColumns.push(TableService.getOrderSequence());
      
      let position = 0;
      columns.forEach(function(column) {  
        if (column.label == "TIER"){
          returnColumns.push(TableService.getBaseColumn([position], column.className, 50));
        } else if (column.label == "Survey"){
          returnColumns.push(TableService.getBaseColumn([position], column.className, 150));
        } else if (column.label == "Competitor"){
          returnColumns.push(TableService.getBaseColumn([position], column.className, 150));
        } else if (column.type == "rank"){
          returnColumns.push(TableService.getRankTableAttribute([position], column.className, 50));
        } else if (column.type == "percent"){
          returnColumns.push(TableService.getPercentTableAttributeRanks([position], column.className, 50, 2, ""));
        } else if (column.type == "nps"){
          returnColumns.push(TableService.getNPSTableAttribute([position], column.className, 50));
        } else if (column.type == "number"){
          returnColumns.push(TableService.getNumericTableAttributeRanks([position], column.className, 50, ""));
        } else if (column.label == "Organization") {
          returnColumns.push(TableService.getBaseTableAttribute([position], column.className, 175));
        } else {
          returnColumns.push(TableService.getBaseTableAttribute([position], column.className, 50));
        }
        position++;
      });    
      TableService.getNumericTableAttribute(["_all"], "dt-right", 50) 
      return returnColumns;
    }
    },
  umnounted() {},
  computed: {
    chartTypeTitle() {
      let chartTitle = this.survey ? this.survey.name : this.clientName;
      // const chartType = this.$parent.$data.criteriaResultsList.find(item => item.name === "Chart Type");
      // chartTitle = chartType ? `${chartType.displayValue} Rank` : "Base Rank";
      // if (this.titleSuffix != null && this.titleSuffix != ""){
      //   chartTitle += " - " + this.titleSuffix;
      // }
      return chartTitle;
    }
  },
  mounted() {},
  created() {},
  watch: {
    inputData: function() {
      this.clearTable();
      if (this.inputData.rows.length > 0) {
        this.processChartData();
      } 
    }
  }
};
</script>
